<div #viewContainer>
  <div class="view-page" [ngClass]="{
      'view-page--column-in': isVisible(viewLayout.Column),
      'view-page--column-out': !isVisible(viewLayout.Column), 
      'view-page--drawer-push': isVisible(viewLayout.Drawer)
    }"
    #view>

    <!-- Columns -->
    <app-view-column-container *ngIf="!(loaderActive$ | async)"></app-view-column-container>

    <!-- Engine -->
    <div class="view-page__engine" #engineContainer>
      <!-- Column toggle -->
      <div class="view-page__column-toggle">
        <app-view-column-toggle></app-view-column-toggle>
      </div>

      <div class="view-page__scene-base" #viewSceneBase>
        <!-- Toolbar -->
        <app-view-toolbar *ngIf="isVisible(viewLayout.Toolbar)"></app-view-toolbar>

        <!-- Media Only (medium / small) -->
        <app-view-navbar *ngIf="isVisible(viewLayout.Navbar)"></app-view-navbar>

        <!-- Logo -->
        <div class="view-page__logo" *ngIf="isVisible(viewLayout.Logo)">
          <app-view-logo></app-view-logo>
        </div>
      </div>

      <!-- Camera Bar -->
      <div class="view-page__camera-bar" #viewNavBar>
        <app-engine-camera-bar
          *ngIf="!(loaderActive$ | async)" 
          [showNav]="isVisible(viewLayout.Camera)"
          [showResetScene]="isVisible(viewLayout.Reset)">
        </app-engine-camera-bar>
      </div>

      <!-- Pagination -->
      <app-view-scene-pagination *ngIf="isVisible(viewLayout.Pagination)"></app-view-scene-pagination>

      <!-- Drawer -->
      <ng-container *ngIf="isVisible(viewLayout.Drawer)">
        <app-view-drawer 
          #drawer
          [enablePagination]="false"
          [expandable]="drawerExpandable"
          (atMinimumChange)="handleDrawerMinimumChange($event)"
          (offsetYChange)="handleDrawerOffsetChange($event)"></app-view-drawer>
      </ng-container>
    </div>

    <!-- Menu -->
    <div class="view-page__menu" *ngIf="isVisible(viewLayout.Menu)" #viewMenu>
      <app-view-menu></app-view-menu>
    </div>
  </div>
</div>

<!-- Input blocker -->
<div class="view-block-input" *ngIf="!(inputEnabled$ | async)"></div>

<!-- Help -->
<app-view-help *ngIf="showHelp$ | async"></app-view-help>

<!-- Loading Experience -->
<app-view-loader *ngIf="loaderActive$ | async">
  <!-- Loader: Play -->
  <app-play-loader *ngIf="(loaderType$ | async) === 'play'" [percent]="loadProgress"></app-play-loader>

  <!-- Loader: Button -->
  <app-button-loader *ngIf="(loaderType$ | async) === 'button'"></app-button-loader>

  <!-- Loader: Click to Interact -->
  <app-hand-loader *ngIf="(loaderType$ | async) === 'hand'"></app-hand-loader>
</app-view-loader>

<app-view-print *ngIf="usePrintImage$ | async"></app-view-print>